import { render, staticRenderFns } from "./VirtualAgentWrapperCX.vue?vue&type=template&id=5eff60ac&"
import script from "./VirtualAgentWrapperCX.vue?vue&type=script&lang=js&"
export * from "./VirtualAgentWrapperCX.vue?vue&type=script&lang=js&"
import style0 from "./VirtualAgentWrapperCX.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VContainer,VFadeTransition})
